import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../../commonComponents/translate';
import FormInput from '../../../../commonComponents/forms/FormInput';

function CreateNote(props) {
  const { t, onChange, note, isLoading, onAddNote } = props;

  const btnCx = cx(
    'btn',
    'btn-dynamic',
    'm-btn--pill',
    { 'm-loader': isLoading },
    { 'm-loader--right': isLoading },
    { 'm-loader--light': isLoading },
  );

  return (
    <div className="note-create-wrapper">
      <h3 className="title">{t('notes.create')}</h3>
      <p className="information">{t('notes.opportunity.add')}</p>
      <FormInput
        id="notes"
        name="notes"
        value={note}
        onChange={onChange}
        placeholder={t('notes.insert')}
        type="textarea"
        disabled={isLoading}
        groupProps={{ className: 'notes' }}
      />
      <div className="button-container">
        <button
          className={btnCx}
          type="button"
          onClick={onAddNote}
          disabled={isLoading || note?.length === 0}
        >
          {t('notes.add')}
        </button>
      </div>
    </div>
  );
}

CreateNote.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  note: PropTypes.string,
  isLoading: PropTypes.bool,
  onAddNote: PropTypes.func.isRequired,
};

CreateNote.defaultProps = {
  note: '',
  isLoading: false,
};

export default translate(CreateNote);
